<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
  >
    <div
      class="bg-white p-6 rounded-lg shadow-lg w-11/12 h-auto max-h-[90vh] overflow-auto"
    >
      <h2 class="text-xl font-semibold mb-4">{{ title }}</h2>
      <form @submit.prevent="submitForm">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div
            v-for="field in formFields"
            :key="field.model"
            class="flex flex-col"
          >
            <label class="mr-2 text-sm font-medium text-gray-700">
              {{ field.label }}:
            </label>
            <select
              v-if="field.type === 'select'"
              v-model="localData[field.model]"
              class="border border-gray-300 rounded p-2 text-sm"
              @change="handleSelectChange(field.model, localData[field.model])">
              <option value="" disabled>Selecciona una opción</option>
              <option
                v-for="(option, idx) in field.options"
                :key="idx"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <input
              v-else-if="field.type === 'date'"
              type="date"
              v-model="localData[field.model]"
              class="border border-gray-300 rounded p-2 text-sm"
            />
            <textarea
              v-else-if="field.type === 'textarea'"
              v-model="localData[field.model]"
              class="border border-gray-300 rounded p-2 text-sm"
            ></textarea>

            <div v-else-if="field.type === 'toggle'" class="flex items-center">
              <label class="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  class="sr-only peer"
                  v-model="localData[field.model]"
                />
                <div
                  class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-500 peer-focus:ring-2 peer-focus:ring-blue-300 transition-all"
                ></div>
                <div
                  class="w-5 h-5 bg-white rounded-full shadow peer-checked:translate-x-5 peer-checked:border-blue-500 absolute left-0.5 top-0.5 transition-all"
                ></div>
              </label>
            </div>

            <div v-else-if="field.type === 'checkbox'" class="flex items-center justify-center bg-gray-50">
                <input type="checkbox" v-model="localData[field.model]"
                  class="appearance-none w-6 h-6 bg-gray-100 border-2 border-gray-300 rounded-lg checked:bg-blue-600 focus:ring-blue-500 focus:ring-2 cursor-pointer transform scale-150" />
            </div>

            <div v-else-if="field.type === 'label'" class="flex items-center justify-center bg-gray-50">
              <label class="mr-2 text-sm font-medium text-gray-700">
                {{ localData[field.model] }}
              </label>
            </div>

            <input
              v-else
              type="text"
              @input="calculate(field.model)"
              v-model="localData[field.model]"
              class="border border-gray-300 rounded p-2 text-sm"
            />
          </div>
        </div>

        <div class="mt-6 flex justify-center space-x-4">
          <button
            type="button"
            @click="$emit('close')"
            class="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            {{ submitButtonText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedData: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "Nuevo",
    },
    formFields: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    submitButtonText: {
      type: String,
      default: "Guardar",
    },
  },
  data() {
    return {
      localData: { ...this.selectedData },
    };
  },
  methods: {
    submitForm() {
      if( this.title === 'Actualizar Producto' ){
        if(this.localData['utilidadE'] !== undefined && this.localData['precioventa'] !== undefined){
          this.localData['utilidadE'] = parseFloat(this.localData['utilidadE'].replace(/,/g, '')),
          this.localData['precioventa'] = parseFloat(this.localData['precioventa'].replace(/,/g, ''));
        }
      }
      this.$emit("updateData", this.localData);
      console.log("data update", this.localData);
    },
    calculate(model) {
      if (model === 'utilidad' || model === 'costo') {
        if (this.localData['utilidad'] !== undefined && this.localData['costo'] !== undefined) {
          const utilidad = parseFloat(this.localData['utilidad']) || 0;
          const costo = this.localData['costo'];
          const precio_venta = costo/((100-utilidad)/100);
          this.localData['utilidadE'] = (precio_venta - costo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          this.localData['precioventa'] = parseFloat(precio_venta).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }
    },
    handleSelectChange(model, value) {
      if (this.title === 'Actualizar Producto') {
        if (model === 'familia') {
          this.localData['categoría'] = undefined;
          this.localData['codigo'] = '';
          this.$emit('familia-change', value);
        }
        if (model === 'categoría') {
          this.localData['subcategoría'] = undefined;
          this.$emit('categoria-change', this.localData['familia'], value);
        }
        if (this.localData['categoría'] !== undefined) {
          let ruta = `${this.localData['familia']}/${this.localData['categoría']}/${this.localData['subcategoría']}`
          if (this.localData['subcategoría'] === undefined)
            ruta = `${this.localData['familia']}/${this.localData['categoría']}/${null}`;
            this.$axios.get(`/getConsecutivo/${ruta}`).then(response => {
              this.localData['Codigo'] = response.data.identificador;
            });
        }
        if (model === 'unidad') {
          this.localData['unidad'] = value;
        }
      
        if (model === 'familia') {
          this.$emit('familia-change', value);
        }
      }
    },
  },
  watch: {
    selectedData: {
      handler(newValue) {
        this.localData = { ...newValue };
      },
      deep: true,
    },
  },
  mounted(){
    if( this.title === 'Actualizar Producto' ){
      const utilidad = parseFloat(this.localData['utilidad']) || 0;
      const costo = this.localData['costo'];
      const precio_venta = costo/((100-utilidad)/100);
      this.localData['utilidadE'] = (precio_venta - costo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.localData['precioventa'] = parseFloat(precio_venta).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>
